import { Modal, useModals } from 'almanac-ui/Modal'
import { RootProps } from './Types'
import Styles from './Root.module.scss'
import cx from 'classnames'
import { Button } from 'blaze-ui/Button'
import { useInterruptBrowserBack } from '../useInterruptBrowserBack'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { WizardTourPortal } from '../WizardTour/WizardTourPortal'
import { WizardTour } from '../WizardTour/WizardTour'
import { BottomButtons } from 'components/DocRightRailV2/BottomButtons/BottomButtons'
import { ConfirmCloseModal } from '../ConfirmCloseModal/ConfirmCloseModal'
import { useCallback } from 'react'

const Root = ({
  children,
  bodyClassName,
  'aria-labelledby': ariaLabelledBy,
  onClose,
  type,
  closeModalOnCancel = true,
}: RootProps) => {
  const { closeModal, openModal, closeAllModals } = useModals()
  useInterruptBrowserBack()
  const isDesktopWizardsUpdatesOn = useFlipperFlag('desktop_wizards_updates')
  const isWizardTourEnabled = useFlipperFlag('wizards_tour')
  const isAdsEnabled = useFlipperFlag('ads_enabled')

  const handleClose = useCallback(() => {
    isAdsEnabled && onClose?.()
    closeModal()
  }, [onClose, closeModal, isAdsEnabled])

  const handleCloseAllModals = useCallback(() => {
    isAdsEnabled && onClose?.()
    closeAllModals()
  }, [onClose, closeAllModals, isAdsEnabled])

  return (
    <>
      <Modal.Root
        size="fullscreen"
        bodyClassName={cx(Styles.root, bodyClassName)}
        aria-labelledby={ariaLabelledBy}
        onClose={handleClose}
      >
        <ResponsiveDesign.Desktop>
          {!isDesktopWizardsUpdatesOn && (
            <div className={Styles.cancelButtonContainer}>
              <Button
                onPress={() => {
                  onClose?.()
                  if (closeModalOnCancel) {
                    closeModal()
                  }
                }}
                variant="secondary"
                size="lg"
              >
                Cancel
              </Button>
            </div>
          )}
          <div
            className={Styles.wizardUnderlay}
            data-testid="wizard-underlay"
            onClick={() => {
              openModal(
                ConfirmCloseModal,
                { onCancel: closeModal, onConfirm: handleCloseAllModals, onPressOutside: handleClose },
                { newStack: true },
              )
            }}
          />
        </ResponsiveDesign.Desktop>
        <div className={Styles.content}>{children}</div>
      </Modal.Root>
      {isWizardTourEnabled && type && (
        <WizardTourPortal>
          <WizardTour type={type} />
          <BottomButtons videoTutorialType={type} />
        </WizardTourPortal>
      )}
    </>
  )
}

export { Root }
